import React, { useState, memo, useEffect } from "react";
import {
  Button,
  ButtonGroup,
  Box,
  IconButton,
  MenuItem,
  TextField,
  Dialog,
  AppBar,
  Toolbar,
  Typography,
  Slide,
  TableContainer,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Grid,
  FormControlLabel,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSnackbar } from "notistack";
import InputField from "../../../../reusable-component/InputField";
import LoadingIcon from "../../../../reusable-component/LoadingIcon";
import { PostgresApi } from "../../../../services/PostgresApi";
import { useAxios } from "../../../../contexts/AxiosProvider";
import { getEnvironmentConfig } from "../../../../constants/CloudConstant";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const nameRegex = /^[a-zA-Z0-9_]{1,35}$/;

const NodeModalReadPostgres = ({
  open,
  handleClose,
  nodeId,
  nodeName,
  nodes,
  edges,
  changeNodeName,
  setNodes,
  workflow,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const axios = useAxios();

  console.log(workflow);
  const INITIALSTATE = {
    format: "database",
    db_type: "postgres",
    action: "",
    persist: false,
    alias: "",
    persist_type: "",
    distinct_rows: false,
    delimiter: ",",
    pagination: false,
    sample_view: true,
    // database:
    //   workflow.engagement.clientEntity.domainEntity.domainName ===
    //   "Business Operations"
    //     ? "BusinessOperation"
    //     : workflow.engagement.clientEntity.domainEntity.domainName ===
    //       "Translational Research"
    //     ? "CapsidBusinessIntelligence"
    //     : "",
    database: getEnvironmentConfig().POSTGRES_DATABASE_WAREHOUSE,
    schema_name: "",
    table_name: "",
  };

  const [formField, setFormField] = useState(INITIALSTATE);
  const [disableForm, setDisableForm] = useState(false);
  const [headerName, setHeaderName] = useState([]);
  const [fetchedHeader, setFetchedHeader] = useState([]);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [tempHeader, setTempHeader] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [schemaData, setSchemaData] = useState({
    schemas: [
      {
        schema_name: "",
      },
    ],
  });
  const [tableData, setTableData] = useState({});

  const handleHeaderChange = (obj) => {
    const selectedIndex = headerName.findIndex((object) => {
      return object.header === obj.header;
    });

    if (selectedIndex === -1 && obj.checked) {
      setHeaderName([...headerName, obj]);

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              header: obj.header,
              alias: obj.alias,
              checked: true,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && obj.checked) {
      setHeaderName((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              header: obj.header,
              alias: obj.alias,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }
          return object;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              header: obj.header,
              alias: obj.alias,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && !obj.checked) {
      setHeaderName((current) =>
        current.filter((object) => {
          return object.header !== obj.header;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              checked: false,
              alias: "",
              cast_datatype: "string",
              attribute_type: "static",
              default_value: "",
            };
          }

          return object;
        })
      );
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = fetchedHeader.map((n) => {
        const all = {
          header: n.header,
          alias: n.alias,
          checked: true,
          cast_datatype: "string",
          attribute_type: "static",
          default_value: "",
        };
        return all;
      });
      setHeaderName(newSelecteds);
      return;
    }
    setHeaderName([]);
  };

  const isSelected = (name) => {
    const selectedIndex = headerName.findIndex((object) => {
      return object.header === name;
    });

    return selectedIndex !== -1;
  };

  const store = JSON.parse(sessionStorage.getItem("allNodes"));

  const getLocalData = () => {
    if (store) {
      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          setFormField(node.formField.read_postgres);
          setHeaderName(node.headerName);
          setTempHeader(node.headerName);
          setFetchedHeader(node.fetchedHeader);
          if (node.disabled) {
            setDisableForm(node.disabled);
          }
        }
      });
    }
  };

  useEffect(() => {
    setFormField(INITIALSTATE);
    setDisableForm(false);
    setFetchedHeader([]);
    setHeaderName([]);
    getLocalData();
    fetchPostgresSchemas();
  }, [nodeId]);

  const handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormField({
      ...formField,
      [name]: value,
    });
  };

  const handleResetForm = () => {
    setFormField(INITIALSTATE);
  };

  const compareTwoArrayOfObjects = (
    first_array_of_objects,
    second_array_of_objects
  ) => {
    return (
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some(
          (element_2) =>
            element_1.header === element_2.header &&
            element_1.tableAlias === element_2.tableAlias &&
            element_1.alias === element_2.alias &&
            element_1.checked === element_2.checked
        )
      )
    );
  };

  const handleFormsubmit = async (e) => {
    e.preventDefault();
    if (!formField.alias.match(nameRegex)) {
      enqueueSnackbar("Alias Contains Special Character!!", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });

      return;
    }

    if (headerName.length === 0) {
      enqueueSnackbar("Please select atleast one column !", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      return;
    }

    const newHeaderName = [];

    headerName.forEach((item) => {
      newHeaderName.push({ ...item, tableAlias: formField.alias });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];

    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (
            count <= connectedNodes.length &&
            node.id === connectedNodes[count]
          ) {
            node.position.x += 0.1;
            count++;
          }

          return node;
        })
      );
    }

    sessionStorage.setItem("updatedNodes", JSON.stringify(connectedNodes));

    setHeaderName(newHeaderName);

    const getAllNodes = JSON.parse(sessionStorage.getItem("allNodes") || "[]");

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem("allNodes", JSON.stringify(newFormData));
    }

    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        el.data.label = formField.alias;
      }
    });

    const sendFormData = {
      y_axis,
      nodeId,
      nodeName,
      formField: { read_postgres: formField, alias: formField.alias },
      disabled: true,
      step_name: nodeName,
      headerName: newHeaderName,
      fetchedHeader,
    };

    changeNodeName(nodes);

    setDisableForm(true);

    sessionStorage.setItem("node", JSON.stringify(nodes));
    sessionStorage.setItem("edges", JSON.stringify(edges));

    const fetchNodesData = JSON.parse(
      sessionStorage.getItem("allNodes") || "[]"
    );
    fetchNodesData.push(sendFormData);

    sessionStorage.setItem("allNodes", JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(
      sessionStorage.getItem("saved_node") || "[]"
    );
    getElements.push(nodeId);
    sessionStorage.setItem("saved_node", JSON.stringify(getElements));
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);

    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });

    const getAllNodes = JSON.parse(sessionStorage.getItem("allNodes"));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el["disabled"] = false;
      }
    });

    sessionStorage.setItem("allNodes", JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem("saved_node"));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem("saved_node", JSON.stringify(newSavedElement));
  };

  useEffect(() => {
    if (formField.schema_name !== "")
      fetchPostgresTables(formField.schema_name);
  }, [formField.schema_name]);

  const fetchPostgresSchemas = async () => {
    // const domainName = workflow.engagement.clientEntity.domainEntity.domainName;
    const DatabaseType = "Postgres";
    try {
      setLoading(true);
      const response = await PostgresApi.getPostgresSchemas(
        axios,
        DatabaseType
      );
      if (response.status === 200) {
        setSchemaData(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchPostgresTables = async (schema) => {
    // const domainName = workflow.engagement.clientEntity.domainEntity.domainName;
    const DatabaseType = "Postgres";
    try {
      setLoading(true);
      console.log(schema);
      const response = await PostgresApi.getPostgresTables(
        axios,
        schema,
        DatabaseType
      );
      if (response.status === 200) {
        setTableData(response.data);
        if (response.data.length === 0) {
          enqueueSnackbar(`No data found for this schema`, {
            variant: "error",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        }
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchPostgresColumns = async (schemaName, tableName) => {
    // const domainName = workflow.engagement.clientEntity.domainEntity.domainName;
    const DatabaseType = "Postgres";
    try {
      setLoadingBtn(true);
      const response = await PostgresApi.getPostgresColumns(
        axios,
        schemaName,
        tableName,
        DatabaseType
      );
      if (response.status === 200) {
        const header = [];

        const uniqueArray = [];
        const seen = {};

        response.data?.columns.map((item, index) => {
          if (!seen[item.columnName]) {
            seen[item.columnName] = index;
            uniqueArray.push(item.columnName);
          } else {
            const newItem = `${item.columnName}${index}`;
            seen[newItem] = 1;
            uniqueArray.push(newItem);
            uniqueArray[seen[item.columnName]] = `${item.columnName}${
              seen[item.columnName]
            }`;
          }
        });
        uniqueArray.forEach((el) => {
          header.push({
            header: el,
            alias: "",
            checked: true,
            tableAlias: "",
            cast_datatype: "string",
            default_value: "",
            attribute_type: "static",
          });
        });

        setFetchedHeader(header);
        setHeaderName(header);
        setTempHeader([]);
      }
    } catch (error) {
      console.error("Error fetching columns:", error);
      enqueueSnackbar("Error fetching columns", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    } finally {
      setLoadingBtn(false);
    }
  };

  const handleChecked = (event) => {
    setFormField({ ...formField, sample_view: event.target.checked });
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        TransitionComponent={Transition}
        style={{ width: "70%", marginLeft: "30%" }}
      >
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: "relative", backgroundColor: "#fff" }}>
            <Toolbar>
              <IconButton
                edge="start"
                onClick={handleClose}
                aria-label="close"
                sx={{ color: "#00043C" }}
              >
                <CloseIcon />
              </IconButton>
              <Typography
                sx={{ ml: 2, flex: 1, color: "#00043C" }}
                variant="h6"
                component="div"
              >
                {nodeName}
              </Typography>
              <ButtonGroup
                variant="contained"
                aria-label="outlined primary button group"
              >
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  className="outlined-button-color"
                  onClick={handleEdit}
                >
                  Edit
                </Button>
                <Button
                  type="submit"
                  size="small"
                  variant="contained"
                  disabled={disableForm}
                  className="button-color"
                >
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>
          <div style={{ margin: "20px" }}>
            <input type="hidden" value={nodeId} />
            <Grid container spacing={2} sx={{ marginTop: 0 }}>
              <Grid item xs={4}>
                <InputField
                  name="alias"
                  label="Alias"
                  value={formField.alias}
                  onChange={handleInputChange}
                  size="small"
                  disabled={disableForm}
                  required
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={formField.sample_view}
                      onChange={handleChecked}
                      disabled={disableForm}
                    />
                  }
                  label="Sample View"
                  sx={{ pt: 1 }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ marginTop: 0 }}>
              <Grid item xs={4}>
                <TextField
                  name="database_name"
                  label="Database"
                  value={formField.database}
                  size="small"
                  disabled
                  required
                  fullWidth
                  InputProps={{
                    style: {
                      fontFamily: "'EB Garamond', serif ",
                      fontWeight: 600,
                    },
                  }}
                  InputLabelProps={{
                    style: { fontFamily: "'EB Garamond', serif " },
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  options={schemaData.schemas}
                  getOptionLabel={(option) => option.schema_name}
                  value={
                    formField.schema_name
                      ? { schema_name: formField.schema_name }
                      : null
                  }
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: {
                        name: "schema_name",
                        value: newValue ? newValue.schema_name : "",
                      },
                    });
                  }}
                  inputValue={searchText}
                  onInputChange={(event, newInputValue) => {
                    setSearchText(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="schema_name"
                      label="Schema Name"
                      size="small"
                      disabled={disableForm}
                      required
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        style: {
                          fontFamily: "'EB Garamond', serif ",
                          fontWeight: 600,
                        },
                      }}
                      InputLabelProps={{
                        style: { fontFamily: "'EB Garamond', serif " },
                      }}
                    />
                  )}
                />
              </Grid>
              {formField.schema_name !== "" && (
                <Grid item xs={3}>
                  <TextField
                    name="table_name"
                    select
                    label="Table"
                    value={formField.table_name}
                    onChange={handleInputChange}
                    size="small"
                    disabled={disableForm}
                    required
                    fullWidth
                    InputProps={{
                      style: {
                        fontFamily: "'EB Garamond', serif ",
                        fontWeight: 600,
                      },
                    }}
                    InputLabelProps={{
                      style: { fontFamily: "'EB Garamond', serif " },
                    }}
                  >
                    {tableData[formField.schema_name]?.map((table) => {
                      return (
                        <MenuItem
                          value={table.table_name}
                          key={table.table_name}
                        >
                          {table.table_name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
              )}
              <Grid item xs={2}>
                <Button
                  style={{ width: "100px" }}
                  variant="outlined"
                  onClick={() => {
                    fetchPostgresColumns(
                      formField.schema_name,
                      formField.table_name
                    );
                  }}
                  disabled={formField.table_name === "" || disableForm}
                  className="outlined-button-color"
                >
                  Fetch
                </Button>
              </Grid>
            </Grid>

            {loadingBtn && (
              <Box>
                <LoadingIcon />
              </Box>
            )}

            {!loadingBtn && fetchedHeader.length > 0 && (
              <TableContainer sx={{ maxHeight: 300 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Checkbox
                          color="primary"
                          checked={fetchedHeader.length === headerName.length}
                          onChange={handleSelectAllClick}
                        />
                        Select Columns
                      </TableCell>
                      <TableCell>Columns</TableCell>
                      <TableCell>Alias</TableCell>
                      <TableCell>Datatype</TableCell>
                      {fetchedHeader.some((el) => el.default_value !== "") && (
                        <TableCell>Format</TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {fetchedHeader.map((row, i) => {
                      const isItemSelected = isSelected(row.header);
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={i}
                          selected={isItemSelected}
                        >
                          <TableCell>
                            <Checkbox
                              checked={isItemSelected}
                              disabled={disableForm}
                              onChange={(event) =>
                                handleHeaderChange({
                                  header: row.header,
                                  alias: "",
                                  checked: event.target.checked,
                                  cast_datatype: row.cast_datatype
                                    ? row.cast_datatype
                                    : "string",
                                  default_value: row.default_value,
                                  attribute_type: row.attribute_type,
                                })
                              }
                              inputProps={{ "aria-label": "controlled" }}
                            />
                          </TableCell>
                          <TableCell>{row.header}</TableCell>

                          <TableCell>
                            <TextField
                              name="alias"
                              label="Alias"
                              value={row.alias}
                              disabled={disableForm}
                              onChange={(e) =>
                                handleHeaderChange({
                                  header: row.header,
                                  alias: e.target.value,
                                  checked: true,
                                  cast_datatype: row.cast_datatype
                                    ? row.cast_datatype
                                    : "string",
                                  default_value: row.default_value,
                                  attribute_type: row.attribute_type,
                                })
                              }
                              size="small"
                            />
                          </TableCell>

                          <TableCell>
                            <TextField
                              id="standard-select-currency"
                              select
                              label="Cast Datatype"
                              name="cast_datatype"
                              disabled={disableForm}
                              value={
                                row.cast_datatype ? row.cast_datatype : "string"
                              }
                              onChange={(event) =>
                                handleHeaderChange({
                                  header: row.header,
                                  alias: row.alias,
                                  checked: true,
                                  cast_datatype: event.target.value,
                                  default_value:
                                    event.target.value !== "timestamp"
                                      ? ""
                                      : row.default_value,
                                  attribute_type: row.attribute_type,
                                })
                              }
                              style={{ width: "100%" }}
                              size="small"
                            >
                              <MenuItem value="int">Integer</MenuItem>
                              <MenuItem value="string">String</MenuItem>
                              <MenuItem value="float">Float</MenuItem>
                              <MenuItem value="timestamp">Timestamp</MenuItem>
                            </TextField>
                          </TableCell>
                          {row.cast_datatype === "timestamp" && (
                            <TableCell>
                              <TextField
                                id="standard-select-currency"
                                select
                                required
                                label="Format"
                                name="timestamp_format"
                                disabled={disableForm}
                                value={row.default_value}
                                onChange={(event) =>
                                  handleHeaderChange({
                                    header: row.header,
                                    alias: row.alias,
                                    checked: true,
                                    cast_datatype: row.cast_datatype
                                      ? row.cast_datatype
                                      : "string",
                                    default_value: event.target.value,
                                    attribute_type: row.attribute_type,
                                  })
                                }
                                style={{ width: "100%" }}
                                size="small"
                              >
                                <MenuItem value="dd-MM-yyyy">
                                  dd-MM-yyyy
                                </MenuItem>
                                <MenuItem value="dd-MM-yyyy HH">
                                  dd-MM-yyyy HH
                                </MenuItem>
                                <MenuItem value="dd-MM-yyyy HH:mm">
                                  dd-MM-yyyy HH:mm
                                </MenuItem>
                                <MenuItem value="dd-MM-yyyy HH:mm:ss">
                                  dd-MM-yyyy HH:mm:ss
                                </MenuItem>
                                <MenuItem value="yyyy-MM-dd">
                                  yyyy-MM-dd
                                </MenuItem>
                                <MenuItem value="yyyy-MM-dd HH">
                                  yyyy-MM-dd HH
                                </MenuItem>
                                <MenuItem value="yyyy-MM-dd hh:mm">
                                  yyyy-MM-dd hh:mm
                                </MenuItem>
                                <MenuItem value="yyyy-MM-dd HH:mm:ss">
                                  yyyy-MM-dd HH:mm:ss
                                </MenuItem>
                              </TextField>
                            </TableCell>
                          )}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            <Grid container spacing={2} sx={{ marginTop: 0 }}>
              <Grid item xs={4}>
                <TextField
                  id="outlined-basic"
                  select
                  label="Persist"
                  variant="outlined"
                  value={formField.persist}
                  name="persist"
                  onChange={handleInputChange}
                  size="small"
                  fullWidth
                  disabled={disableForm}
                  required
                  InputProps={{
                    style: {
                      fontFamily: "'EB Garamond', serif ",
                      fontWeight: 600,
                    },
                  }}
                  InputLabelProps={{
                    style: { fontFamily: "'EB Garamond', serif " },
                  }}
                >
                  <MenuItem value={true}>true</MenuItem>
                  <MenuItem value={false}>false</MenuItem>
                </TextField>
              </Grid>
              {formField.persist === true && (
                <Grid item xs={4}>
                  <TextField
                    id="outlined-basic"
                    select
                    label="Persist Type"
                    variant="outlined"
                    value={formField.persist_type}
                    name="persist_type"
                    onChange={handleInputChange}
                    size="small"
                    disabled={disableForm}
                    required
                    fullWidth
                  >
                    <MenuItem value="DISK_ONLY">DISK_ONLY</MenuItem>
                    <MenuItem value="DISK_ONLY_2">DISK_ONLY_2</MenuItem>
                    <MenuItem value="MEMORY_ONLY">MEMORY_ONLY</MenuItem>
                    <MenuItem value="MEMORY_ONLY_2">MEMORY_ONLY_2</MenuItem>
                    <MenuItem value="MEMORY_AND_DISK">MEMORY_AND_DISK</MenuItem>
                    <MenuItem value="MEMORY_AND_DISK_2">
                      MEMORY_AND_DISK_2
                    </MenuItem>
                  </TextField>
                </Grid>
              )}
            </Grid>

            <Grid container spacing={2} sx={{ marginTop: 0 }}>
              <Grid item xs={4}>
                <TextField
                  name="action"
                  label="Action"
                  value={formField.action}
                  onChange={handleInputChange}
                  size="small"
                  disabled={disableForm}
                  fullWidth
                  // style={{ width: "100%", marginTop: "15px", marginLeft: 18 }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  id="outlined-select-currency"
                  select
                  label="Distinct Rows"
                  size="small"
                  value={formField.distinct_rows}
                  onChange={(event) => {
                    setFormField({
                      ...formField,
                      distinct_rows: event.target.value,
                    });
                  }}
                  disabled={disableForm}
                  fullWidth
                  // style={{ width: "100%", marginTop: "15px", marginLeft: 30 }}
                >
                  <MenuItem value="true">true</MenuItem>
                  <MenuItem value="false">false</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </div>
        </form>
      </Dialog>
    </div>
  );
};

export default memo(NodeModalReadPostgres);
